export const FIELDS = {
  ID: 'id',
  STATUS_NAME: 'statusName',
  INVOICE_DATE: 'invoiceDate',
  DUE_DATE: 'dueDate',
  AGING: 'aging',
  DAYS: 'days',
  INVOICE_NUMBER: 'invoiceNumber',
  SALES_ORDER_ID: 'salesOrderId',
  STATUS_ID: 'statusId',
  COMPANY_ID: 'companyId',
  COMPANY_NAME: 'companyName',
  CONTACT_ID: 'contactId',
  CONTACT: 'contact',
  CONTACT_EMAIL: 'contactEmail',
  BILLING_ADDRESS_ID: 'billingAddressId',
  BILLING_ADDRESS: 'billingAddress',
  SHIPPING_ADDRESS_ID: 'shippingAddressId',
  SHIPPING_ADDRESS: 'shippingAddress',
  SALES_PERSON_USER_FULL_NAME: 'salesPersonUserFullName',
  BILLING_TERM_ID: 'billingTermId',
  BILLING_TERM_NAME: 'billingTermName',
  IS_AUTHORIZED: 'isAuthorized',
  SUB_TOTAL: 'subTotal',
  TOTAL_LINE_COST: 'totalLineCost',
  TOTAL_CHARGES_TAXABLE: 'totalChargesTaxable',
  TOTAL_CHARGES_NON_TAXABLE: 'totalChargesNonTaxable',
  TOTAL_CHARGES: 'totalCharges',
  TOTAL_CHARGES_COST: 'totalChargesCost',
  TOTAL: 'total',
  GROSS_PROFIT: 'grossProfit',
  GPMARGIN: 'gpMargin',
  AMOUNT_PAID: 'amountPaid',
  BALANCE: 'balance',
  SHIPPING_PROVIDER_NAME: 'shippingProviderName',
  SHIPPING_METHOD_NAME: 'shippingMethodName',
  SHIPPING_NUMBER: 'shippingNumber',
  AUTHORIZED_BY_USER_FULL_NAME: 'authorizedByUserFullName',
  DATE_AUTHORIZED: 'dateAuthorized',
  DATE_CREATED: 'dateCreated',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  DATE_MODIFIED: 'dateModified',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
  INCO_TERM_ID: 'incoTermId',
  INCO_TERM_NAME: 'incoTermName',
  SALES_PERSON_USER_ID: 'salesPersonUserId',
  SHIP_DATE: 'shipDate',
  SALES_ORDER_NUMBER: 'salesOrderNumber',
  CONTRACT_NUMBER: 'contractNumber',
  CUSTOMER_PO: 'customerPo',
  CURRENCY_TYPE_ID: 'currencyTypeId',
  CURRENCY_TYPE_NAME: 'currencyTypeName',
  CURRENCY_SYMBOL: 'currencySymbol',
  EXCHANGE_RATE: 'exchangeRate',
  SHIPPING_METHOD_ID: 'shippingMethodId',
  SHIPPING_PROVIDER_ID: 'shippingProviderId',
  SHIPPED_BY_USER_ID: 'shippedByUserId',
  SHIPPED_BY_USER_FULL_NAME: 'shippedByUserFullName',
  SHIPPING_NO_CHARGE: 'shippingNoCharge',
  SHIPPING_CHARGE: 'shippingCharge',
  TAX_RATE: 'taxRate',
  IS_TAXABLE: 'isTaxable',
  TAX_NUMBER: 'taxNumber',
  VATNUMBER: 'vatNumber',
  TAX: 'tax',
  SUB_TOTAL_CONVERTED: 'subTotalConverted',
  TOTAL_LINE_COST_CONVERTED: 'totalLineCostConverted',
  TOTAL_CHARGES_TAXABLE_CONVERTED: 'totalChargesTaxableConverted',
  TOTAL_CHARGES_NON_TAXABLE_CONVERTED: 'totalChargesNonTaxableConverted',
  TOTAL_CHARGES_CONVERTED: 'totalChargesConverted',
  TOTAL_CHARGES_COST_CONVERTED: 'totalChargesCostConverted',
  TOTAL_CONVERTED: 'totalConverted',
  SALES_REP_COMMISSION_RATE: 'salesRepCommissionRate',
  COMMISSION_AMOUNT: 'commissionAmount',
  IS_SALES_COMMISSION_PAID: 'isSalesCommissionPaid',
  CREDIT_AMOUNT: 'creditAmount',
  CREDIT: 'credit',
  SHIP_ON_COMPANY_ACCOUNT: 'shipOnCompanyAccount',
  ALWAYS_SHIP_BY: 'alwaysShipBy',
  SHIPPING_ACCOUNT_NUMBER: 'shippingAccountNumber',
  TRACKING_NUMBER: 'trackingNumber',
  COMMENTS: 'comments',
  INTERNAL_COMMENTS: 'internalComments',
  AUTHORIZED_BY_USER_ID: 'authorizedByUserId',
  ON_HOLD: 'onHold',
  QBTXN_ID: 'qbTxnId',
  QBSYNCED: 'qbSynced',
  IS_PROFORMA: 'isProforma',
  CREATED_BY_USER_ID: 'createdByUserId',
  ACTIVE: 'active',
  SHIPMENT_DETAILS__ITN: 'shipmentDetailsItn',
  SHIPMENT_DETAILS__WEIGHT: 'shipmentDetailsWeight',
  SHIPMENT_DETAILS__CARTONS: 'shipmentDetailsCartons',
  SHIPMENT_DETAILS__DIMS1: 'shipmentDetailsDims1',
  SHIPMENT_DETAILS__DIMS2: 'shipmentDetailsDims2',
  IS_SHIPPED: 'isShipped',};